import React from 'react';
import './Bags.css';
import ProductCard from './ProductCard';

function Bags() {
  const templates = [
    { name: 'Kente Cloth Tote Bag', price: 55, image: '👜', imageUrl: '/Ankara bag.jfif', description: 'Spacious Kente cloth tote for daily use' },
    { name: 'Wax Print Shoulder Bag', price: 65, image: '👝', imageUrl: '/Ankara bag.jfif', description: 'Stylish shoulder bag with vibrant wax prints' },
    { name: 'Ankara Crossbody Bag', price: 50, image: '👜', imageUrl: '/Ankara bag.jfif', description: 'Convenient crossbody bag with Ankara patterns' },
    { name: 'Beaded Evening Clutch', price: 75, image: '👛', imageUrl: '/Ankara bag.jfif', description: 'Elegant beaded clutch for special occasions' },
    { name: 'Leather Tribal Backpack', price: 85, image: '🎒', imageUrl: '/Ankara bag.jfif', description: 'Premium leather backpack with tribal designs' },
    { name: 'Adire Market Bag', price: 60, image: '👜', imageUrl: '/Ankara bag.jfif', description: 'Authentic Adire market bag' },
  ];

  const bags = Array.from({ length: 20 }, (_, index) => {
    const template = templates[index % templates.length];
    return {
      id: index + 1,
      name: `${template.name} ${index + 1}`,
      price: template.price + (index % 4) * 4,
      image: template.image,
      imageUrl: template.imageUrl,
      description: `${template.description} • ${['Heritage', 'Modern', 'Classic', 'Festival'][index % 4]}`,
    };
  });

  return (
    <div className="bags-section">
      <div className="section-header">
        <div>
          <p className="section-eyebrow">Modern African Accessories</p>
          <h2>African Bags & Accessories</h2>
          <p>Handcrafted, beautiful, and designed for every occasion.</p>
        </div>
        <div className="section-badges">
          <span>20 curated bags</span>
          <span>Premium finish</span>
          <span>Ready to wear</span>
        </div>
      </div>
      <div className="products-grid">
        {bags.map((bag) => (
          <ProductCard key={bag.id} product={bag} />
        ))}
      </div>
    </div>
  );
}

export default Bags;
